import SuccessIcon from '@/fo/icons/base/icons/check.svg';
import ErrorIcon from '@/fo/icons/base/icons/close.svg';

import { styles } from './UiKitToastBase.styles';

export interface UiKitToastBaseProps {
  message: string;
  status: 'success' | 'error';
}

export function UiKitToastBase({ message, status }: UiKitToastBaseProps) {
  const slots = styles({ status });
  return (
    <div className={slots.base()}>
      <div className={slots.icon()}>
        {status === 'success' ? (
          <SuccessIcon className={slots.iconInner()} />
        ) : (
          <ErrorIcon />
        )}
      </div>
      <div className={slots.message()}>{message}</div>
    </div>
  );
}
